import React from 'react';
import IndicatorComplianceTable from './IndicatorComplianceTable.component';
import PreTradeChecker from './PreTradeChecker.component';
import { FundInfoComponentProps } from '../../../layout/general/SimpleGeneralPageWrapper';
import { QueryBoundary } from '../../../utilityComponents/QueryBoundary';
import {
  useIndicatorComplianceQuery,
  type IndicatorCompliancePageModel,
} from '../../../../api/rs-hg/esg';

export interface IndicatorComplianceUnderlyingTableData {
  position_name: string;
  involvement: string;
  indicator: string;
  value: number;
  pass_fail: string;
  position_id: string;
  gmid: string;
  is_edited: boolean;
}

export interface IndicatorComplianceTableData {
  indicator: string;
  name: string;
  description: string;
  limit_type: string;
  limit: number;
  involvement: string;
  value: number | string;
  pass_fail: string;
  unit: string;
  underlying: IndicatorComplianceUnderlyingTableData[];
}

const IndicatorCompliance: React.FC<FundInfoComponentProps> = ({
  fundId,
  positionDate,
}) => {
  const indicatorComplianceQuery = useIndicatorComplianceQuery(
    fundId,
    positionDate,
  );

  return (
    <QueryBoundary<IndicatorCompliancePageModel>
      isLoading={indicatorComplianceQuery.isLoading}
      isFetching={
        indicatorComplianceQuery.isFetching && !indicatorComplianceQuery.data
      }
      isError={indicatorComplianceQuery.isError}
      error={indicatorComplianceQuery.error}
      data={
        indicatorComplianceQuery.data?.data?.configs
          ? indicatorComplianceQuery.data
          : null
      }
      loadingMessages={['Loading Indicator Compliance Data']}
      errorMessage="No Data Available."
      noDataMessage="No Data Available."
    >
      {(pageModel) => (
        <>
          <IndicatorComplianceTable
            positionDate={
              pageModel.returned_position_date ??
              pageModel.selected_position_date ??
              positionDate
            }
            fundId={fundId}
            data={pageModel.data}
          />
          {pageModel.data.configs.pre_trade_check ? (
            <PreTradeChecker fundId={fundId} positionDate={positionDate} />
          ) : null}
        </>
      )}
    </QueryBoundary>
  );
};

export default IndicatorCompliance;
